/**
 * PartnerIcons.jsx
 * Created by Destin Frasier on 10/23/17.
 */

import PartnerIconSingleton from './partnerIconSingleton';
import BaseIcon from '../BaseIcon';


class PartnerIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = PartnerIconSingleton;
    }
}

export class NationalArchives extends PartnerIcon {}
NationalArchives.defaultProps = {
    iconName: 'rec-icon-national-archives',
    iconClass: 'rec-icon-national-archives',
    alt: 'National Archives'
};

export class DOI extends PartnerIcon {}
DOI.defaultProps = {
    iconName: 'rec-icon-doi',
    iconClass: 'rec-icon-doi',
    alt: 'Bureau of Reclamation'
};

export class TVA extends PartnerIcon {}
TVA.defaultProps = {
    iconName: 'rec-icon-tva',
    iconClass: 'rec-icon-tva',
    alt: 'Tennessee Valley Authority'
};

export class TRE extends PartnerIcon {}
TRE.defaultProps = {
    iconName: 'rec-icon-tre',
    iconClass: 'rec-icon-tre',
    alt: 'Department of The Treasury'
};

export class NPS extends PartnerIcon {}
NPS.defaultProps = {
    iconName: 'rec-icon-nps',
    iconClass: 'rec-icon-nps',
    alt: 'National Park Service'
};

export class USACE extends PartnerIcon {}
USACE.defaultProps = {
    iconName: 'rec-icon-usace',
    iconClass: 'rec-icon-usace',
    alt: 'Army Corps of Engineers'
};

export class ForestService extends PartnerIcon {}
ForestService.defaultProps = {
    iconName: 'rec-icon-forest-service',
    iconClass: 'rec-icon-forest-service',
    alt: 'Forest Service'
};

export class NOAA extends PartnerIcon {}
NOAA.defaultProps = {
    iconName: 'rec-icon-noaa',
    iconClass: 'rec-icon-noaa',
    alt: 'National Oceanic and Atmospheric Administration'
};

export class BLM extends PartnerIcon {}
BLM.defaultProps = {
    iconName: 'rec-icon-blm',
    iconClass: 'rec-icon-blm',
    alt: 'Bureau of Land Management'
};

export class Smithsonian extends PartnerIcon {}
Smithsonian.defaultProps = {
    iconName: 'rec-icon-smithsonian',
    iconClass: 'rec-icon-smithsonian',
    alt: 'Smithsonian'
};

export class FWS extends PartnerIcon {}
FWS.defaultProps = {
    iconName: 'rec-icon-fws',
    iconClass: 'rec-icon-fws',
    alt: 'Fish & Wildlife'
};

export class DOT extends PartnerIcon {}
DOT.defaultProps = {
    iconName: 'rec-icon-dot',
    iconClass: 'rec-icon-dot',
    alt: 'Department of Transportation'
};

export class BEP extends PartnerIcon {}
BEP.defaultProps = {
    iconName: 'rec-icon-bep',
    iconClass: 'rec-icon-bep',
    alt: 'Bureau of Engraving and Printing'
};